// Console.log fix
if ( typeof console == 'undefined' ) {
  console = {};
}
if ( typeof console.log == 'undefined' ) {
  console.log = function () {}
}
if ( typeof console.error == 'undefined' ) {
  console.error = function () {}
}
let $body = null;
let $html = null;
let $site = null;
let fz;

$(document).ready(function($) {
  $body = $('body');
  $html = $('html');
  $site = $('#site-content');

  if ( is_webkit() ) {
    $body.addClass('webkit');
  }
  $body.addClass('body-ready');

  $(window).resize();
});

$(window).on('load',function() {
  $('body').addClass('page-loaded');
  $(window).resize();
  setTimeout(function() {
    $(window).resize();
  },500);
});
window.addEventListener("orientationchange", function() {
  $(window).resize();
}, false);


// $(window).resize(function() {
//   // Font size
//   if ( $site ) {
//     if ( $site.length ) {
//       let w = $site.width();
//       let h = $(window).height();
//       if ( !is_mobile() ) {
//         fz = Math.min( w/1440);
//         fz = Math.min(fz, 1);
//       } else {
//         if ( w > 480 ) {
//           w = 480;
//         }
//         fz = w / 390;
//       }
//       $html.css('font-size', ( fz * 100 ) + '%');
//       $('.js-fz').css('transform','scale('+fz+')');
//     }
//   }
//   $(window).scroll();
// });

// ------------------------ COMMONS

var $mobile_detect = null;
function is_mobile () {
  if ( !$mobile_detect ) {
    $mobile_detect = $('#mobile-detect');
  }
  return $mobile_detect.is(':visible');
}
function is_webkit () {
  return "webkitLineBreak" in document.documentElement.style;
}
function wait () {
  return '<div class="wait"></div>';
}
function remove_wait ( $wrap ) {
  $wrap.find('.wait').fadeOut(200, function () {
    $(this).remove();
  });
}
function scrollto ( $elem, is_force_scroll = true ) {
  let s = $(window).scrollTop();
  let ot = $elem.offset().top;
  let hh = $('.header').height();
  let bh = $elem.outerHeight(true);
  let wh = $(window).height();
  if ( $elem.is('.block-full__scroll__anchor')) {
    hh = 0;
  }
  let st = ot - hh;
  //console.log(s-hh, st, s + wh, ot + bh );
  if ( !is_force_scroll && s - hh < st && s + wh > ot + bh ) {
    return;
  }
  $('body,html').animate({
    scrollTop: st,
  }, {
    duration: 500
  });
}

// Scroll Down
$(document).on('click', 'a[href*="#"]', function( e ) {
  const regex = /^(.*)#(.*)$/gi;
  const href = $(this).attr('href');
  const m = regex.exec(href);
  if ( m ) {
    let base_url = m[1];
    if ( !/^\//.test(base_url)) {
      base_url = location.pathname;
    }
    const id = m[2];
    let $block = $('#'+id);
    const $block_mobile = $('#'+id+'--mobile');
    if ( is_mobile() && $block_mobile.length ) {
      $block = $block_mobile;
    }
    if ( $block.length && ( !base_url || base_url === location.pathname ) ) {
      e.preventDefault();
      scrollto($block);
    }
  }
});

// Pros
$(document).ready(function() {
  $('.pros').once('sw-pros').each(function () {
    const $w = $(this);
    const $hovers = $w.find('.pros__item__hover');
    const $slider = $w.find('.pros__slider');

    $slider.slick({
      arrows: false,
      fade: false,
      dots: true,
      adaptiveHeight: false,
      infinite: false,
      touchMove: false,
      swipe: true,
      centerMode: false,
      slidesToShow: 3,
      variableWidth: false,
      waitForAnimate: false,
      speed: 400,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        }
      }],
    });

    $hovers.on('mouseenter', function () {
      if ( !is_mobile()) {
        $(this).closest('.pros__item').addClass('pros__item--hover');
      }
    }).on('mouseleave', function () {
      if ( !is_mobile()) {
        $(this).closest('.pros__item').removeClass('pros__item--hover');
      }
    });

    $hovers.on('click', function () {
      if ( is_mobile()) {
        $(this).closest('.pros__item').toggleClass('pros__item--hover');
      }
    });
  });
});

// Mattresses
$(document).ready(function() {
  $('.mattresses').once('sw-mattresses').each(function () {
    const $w = $(this);
    const $sliders = $w.find('.mattresses__item__images');

    $sliders.each(function () {
      const $slider = $(this);
      $slider.slick({
        arrows: false,
        fade: false,
        dots: true,
        adaptiveHeight: false,
        infinite: false,
        touchMove: false,
        swipe: true,
        centerMode: false,
        slidesToShow: 1,
        variableWidth: false,
        waitForAnimate: false,
        speed: 400,
      });
    });
  });
});
